<template>
    <div class="switcher">
        <template v-if="chat_list.length">
            <button class="button button__no_min-width button_type_icon" 
                @click="isListOpen = !isListOpen"
            >
                <svg width="16" height="16">
                    <use href="#icon-angle-down" v-if="!isListOpen"></use>
                    <use href="#icon-angle-up" v-else></use>
                </svg>
            </button>

            <v-drop-down-list
                v-if="chat_list.length"
                :list="chat_list"
                :expand="this.isListOpen"
                @click="handleListClick"
            />
        </template>
        <preloader v-else size="ex-small"/>
    </div>
</template>

<script>
import api from '@api'
import preloader from '@components/global/Preloader'
import vDropDownList from '@components/global/DropDownList.vue';
import { mapActions } from 'vuex'
export default {
    name: 'chatSwitcher',
    props: { 
        value: {
            type: Object,
            default: () => {}
        },
        phone: {
            type: String,
            default: () => {}
        }
    },
    components: {
        preloader,
        vDropDownList
    },
    data() {
        return {
            isListOpen: false,
            chat_list: []
        }
    },
    mounted() {
        const list = this.chat_list
        this.value.chat_list.forEach((chat) => {
            const item = chat
            item.name = item.title
            item.phone = this.phone
            list.push(item)
        })
    },
    
    methods: {
        ...mapActions([
            'SELECT_BAR',
            'HARD_RESET_SIDEBAR',
        ]),

        handleListClick(event) {
            this.isListOpen = false
            //this.$emit('click', event)
            this.openChat(event)
        },

        async openChat(button) {
            let contact = null
            const payload =  {
                company_platform_id: button.company_platform_id, 
                phone: button.phone,
            }
            
            await this.getChatDetail(payload).then(res=>{
                contact = res.response
            })
            if(!contact || !contact.id) {
                this.$toast.error('Контакт не найден');
                return
            }
            
            this.HARD_RESET_SIDEBAR()
            this.$nextTick(() => {
                this.SELECT_BAR({
                    name:'chat',
                    selected: {
                        contact
                    }
                })    
            })
        },
        getChatDetail(payload) {
            return api.chat.getChat(payload,'','post').then(response=>{
                return response
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.switcher {
    margin-left: 5px;
}
</style>